export const BRAND = {
  name: "퍼스트디지털은행",
  nameEn: "FIRST DIGITAL BANK",
  slogan: "신뢰로 연결하는 스마트 금융",
  intro: "언제 어디서나 안전하고 편리한 디지털 뱅킹을 제공합니다. 예금·대출·카드·자산관리까지 하나의 앱으로 관리하세요.",
  phone: "1588-1000",
  hours: "고객센터 24시간 · 영업점 평일 09:00-16:00",
};

export const NAV = [
  { id: "products", label: "상품" },
  { id: "digital", label: "디지털뱅킹" },
  { id: "rates", label: "금리안내" },
  { id: "branch", label: "영업점" },
  { id: "inquiry", label: "상담" },
];

export const PRODUCTS = [
  { title: "입출금·예금", desc: "목돈 굴리기부터 자유로운 입출금까지", items: ["자유입출금", "정기예금", "적금", "외화예금"] },
  { title: "대출", desc: "신용·주택·사업자 맞춤 대출", items: ["신용대출", "주택담보", "전세자금", "사업자대출"] },
  { title: "카드", desc: "생활 밀착형 체크·신용카드", items: ["체크카드", "신용카드", "프리미엄 카드", "포인트 적립"] },
  { title: "자산관리", desc: "펀드·ISA·연금 통합 관리", items: ["펀드", "ISA", "연금저축", "로보어드바이저"] },
];

export const DIGITAL = [
  { title: "모바일 뱅킹", desc: "계좌조회·이체·인증서 발급 원스톱" },
  { title: "비대면 계좌개설", desc: "영상 인증으로 5분 내 계좌 개설" },
  { title: "보안 인증", desc: "생체인증·OTP·이상거래 탐지" },
];

export const RATES = [
  { name: "정기예금 12개월", rate: "3.20%", note: "기본" },
  { name: "적금 12개월", rate: "3.50%", note: "기본" },
  { name: "신용대출", rate: "4.80%~", note: "개인별" },
  { name: "주택담보대출", rate: "4.20%~", note: "변동" },
];

export const BRANCHES = [
  { name: "강남금융센터", addr: "서울 강남구 테헤란로 152", tel: "02-555-1001" },
  { name: "여의도지점", addr: "서울 영등포구 여의대로 128", tel: "02-555-1002" },
  { name: "부산센터", addr: "부산 해운대구 센텀로 55", tel: "051-555-1003" },
];

export const FAQ = [
  { q: "비대면 계좌개설이 가능한가요?", a: "만 19세 이상 내국인은 모바일 앱에서 영상 인증 후 계좌를 개설할 수 있습니다." },
  { q: "대출 한도는 어떻게 확인하나요?", a: "앱 내 대출 시뮬레이션 또는 고객센터(1588-1000)를 통해 사전 조회가 가능합니다." },
  { q: "해외송금 수수료는?", a: "디지털 뱅킹 채널 이용 시 건당 5,000원이며, VIP 등급은 면제 혜택이 있습니다." },
];
